import { Link } from 'react-router-dom'
import { Cherry } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '@/lib/auth-context'

/**
 * BalanceBadge — a small, calm cherry-count chip pinned to the top-right,
 * mirroring the leaf nav trigger on the top-left. Rendered app-wide from
 * AppShell, so it shows on Home, Entdecken, and every authed page.
 * Informational only; quiet by design.
 */
export default function BalanceBadge() {
  const { t } = useTranslation()
  const { user, balance } = useAuth()
  if (!user) return null
  // balance stays null when the fetch failed — show a calm placeholder
  // instead of a misleading "0".
  const label = balance === null ? '–' : `${balance}`

  return (
    <Link
      to="/transactions"
      className="fixed right-3 top-3 z-40 flex cursor-pointer items-center gap-1.5 rounded-full border border-silver bg-white/90 px-3 py-1.5 shadow-sm backdrop-blur-sm transition-colors hover:bg-white"
      aria-label={balance === null ? t('common.cherries_balance_unavailable') : t('common.cherries_balance', { count: balance })}
    >
      <Cherry className="h-4 w-4 text-terra" />
      <span className="font-body text-sm font-medium tabular-nums text-ink">{label}</span>
    </Link>
  )
}
